import lng from '@lightningjs/core';
import { Colors, Storage, Utils } from '@lightningjs/sdk';
let Subtitles;
let profileId;
export default class SubtitlesLanguage extends lng.Component {
  static _template() {
    return {
      h: 50,
      Column: {
        h: 60,
        flex: { direction: 'row', alignItems: 'center' },
        Wrapper: {
          w: 40,
          h: 85,
          flex: { direction: 'row', alignItems: 'center' },
          Icon: {},
        },
        Language: { y: 5 },
      },
      LanguageBorder: {
        collision: true,
        texture: lng.Tools.getRoundRect(515, 60, 13, 4, Colors('#000000').get(), false),
      },
    };
  }

  set index(val) {
    this._index = val;
  }

  set subLanguage(val) {
    return (this._subLanguage = val);
  }
  get subLanguage() {
    return this._subLanguage;
  }
  get _Icon() {
    return this.tag('Icon');
  }
  get _Language() {
    return this.tag('Language');
  }
  get _LanguageBorder() {
    return this.tag('LanguageBorder');
  }
  _enable() {
    this._Icon.patch({
      x: 30,
      texture: null,
    });
    profileId = Storage.get('profileId');
    Subtitles =
      Storage.get(`audiosubtitles-${profileId}`) && Storage.get(`audiosubtitles-${profileId}`);
    if (Subtitles.subtitle) {
      if (Subtitles.subtitle == this._subLanguage.lng) {
        this._Icon.patch({
          x: 30,
          texture: lng.Tools.getSvgTexture(
            Utils.asset('images/settings-icons/checkmark.svg'),
            30,
            30
          ),
        });
        this._Language.patch({
          color: Colors('#FAFAFA').get(),
        });
        this._isSelected = true;
        this.parent._selectedLanguage = this;
        Subtitles =
          Storage.get(`audiosubtitles-${profileId}`) && Storage.get(`audiosubtitles-${profileId}`);
        Storage.set(`audiosubtitles-${profileId}`, {
          ...Subtitles,
          subtitle: this._subLanguage.lng,
        });
      }
    } else {
      if (this.subLanguage.language === 'None') {
        let Subtitle = Storage.get(`audiosubtitles-${profileId}`);
        Storage.set(`audiosubtitles-${profileId}`, { ...Subtitle, subtitle: this.subLanguage.lng });
        this._Icon.patch({
          x: 30,
          texture: lng.Tools.getSvgTexture(
            Utils.asset('images/settings-icons/checkmark.svg'),
            30,
            30
          ),
        });
        this._Language.patch({
          color: Colors('#FAFAFA').get(),
        });
        this._isSelected = true;
        this.parent._selectedLanguage = this;
      }
    }
  }
  _firstEnable() {
    this._Language.patch({
      x: 40,
      text: {
        text: this._subLanguage.language,
        fontSize: 36,
        fontFace: 'OpenSans-Regular',
      },
      color: Colors('#D6D6D6').get(),
    });
  }
  _focus() {
    super._focus();
    if (!this._isSelected) {
      this._Language.patch({
        color: Colors('#FAFAFA').get(),
      });
    }
    this._LanguageBorder.patch({
      texture: lng.Tools.getRoundRect(515, 60, 13, 4, Colors('#02AC25').get(), false),
    });
  }
  _unfocus() {
    super._unfocus();
    if (!this._isSelected) {
      this._Language.patch({
        color: Colors('#D6D6D6').get(),
      });
    }
    this._LanguageBorder.patch({
      texture: lng.Tools.getRoundRect(515, 60, 13, 4, Colors('#000000').get(), false),
    });
  }
  _init() {
    this._selectedLanguage = null;
  }
  _handleEnter() {
    // If this option is already selected, deselect it
    if (this.parent._selectedLanguage != this) {
      if (this.parent._selectedLanguage) {
        this.parent._selectedLanguage._Icon.patch({
          texture: null,
        });
        this.parent._selectedLanguage._Language.patch({
          text: { textColor: Colors('#D6D6D6').get() }, // set color to original when deselected
        });
        this.parent._selectedLanguage._isSelected = false;
      }
      this._Icon.patch({
        x: 30,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('images/settings-icons/checkmark.svg'),
          30,
          30
        ),
      });
      this._Language.patch({
        text: { textColor: Colors('#FAFAFA').get() }, // set color to red when selected
      });
      Subtitles =
        Storage.get(`audiosubtitles-${profileId}`) && Storage.get(`audiosubtitles-${profileId}`);
      Storage.set(`audiosubtitles-${profileId}`, {
        ...Subtitles,
        subtitle: this.subLanguage.lng,
      });
      this._isSelected = true;
      this.parent._selectedLanguage = this;
    }
  }

  // Magic Remote

  _handleHover() {
    this.fireAncestors('$setState', 'Subtitle');
    this.fireAncestors('$setSubtitleIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }
}
